/*!
 * tool-rating.js — extracted 2026-07-08 from resources/views/components/tool-rating.blade.php
 * (the whole inline rating-widget script: star rating with offline queue +
 * Background Sync replay, comment form with char counter, AJAX comment list /
 * reply threads, pending-comments localStorage store, likes, 3-dot
 * delete/report menu, admin markdown editor + DOMPurify lazy loaders,
 * @mention rendering, email-anchor comment focus).
 *
 * Loaded SYNCHRONOUSLY (no defer) at the exact old inline position — right
 * after the widget markup at the bottom of the component — so document-order
 * execution is unchanged.
 *
 * Expects this inline-shim global (set by the component right before this tag):
 *   window.__RATING_CFG = {
 *     slug, csrf, locale,
 *     routes: { store, check, comment, commentList, commentReplies,
 *               commentDelete, commentReport, commentStatus, commentUpdate,
 *               adminPreview },
 *     l10n:   { ...every tools.rating.* string the widget shows, plus
 *               feedback_cancel, reply_forms / comment_forms plural maps... },
 *     flags:  { currentUser: {id,display_name,verified,is_pro} | null,
 *               isAdminSession: bool },
 *     authors: { "Display Name": "username"|null, ... } // SSR @mention roster
 *   }
 */
(function(){
    'use strict';
    var CFG = window.__RATING_CFG || {routes:{},l10n:{},flags:{}};
    var starsEl = document.getElementById('rwStars');
    var thanksEl = document.getElementById('rwThanks');
    var thanksText = document.getElementById('rwThanksText');
    var commentEl = document.getElementById('rwComment');
    var commentOk = document.getElementById('rwCommentOk');
    var errorEl = document.getElementById('rwError');
    var changeEl = document.getElementById('rwChange');
    var changeLink = document.getElementById('rwChangeLink');
    var submitBtn = document.getElementById('rwSubmitComment');
    var nameInput = document.getElementById('rwName');
    var textInput = document.getElementById('rwText');
    var toggleEl = document.getElementById('rwToggle');
    var toggleLink = document.getElementById('rwToggleLink');
    if (!starsEl) return;

    // Character counter + auto-grow (the big-site pattern: the field grows
    // with the text instead of scrolling, and a plain "N / 2000" appears on
    // focus so the ceiling is known BEFORE it is hit, not 200 chars from it).
    var charCountEl = document.getElementById('rwCharCount');
    if(textInput && charCountEl){
        var renderCount = function(){
            var len = textInput.value.length;
            var remaining = CMT_MAX - len;
            charCountEl.textContent = len + ' / ' + CMT_MAX;
            charCountEl.style.color = remaining <= 50 ? 'var(--danger)' : 'var(--text-muted)';
            if(remaining <= 200 && CHARS_REMAINING){
                charCountEl.textContent += ' · ' + CHARS_REMAINING.replace(':n', remaining);
            }
        };
        var autoGrow = function(){
            textInput.style.height = 'auto';
            textInput.style.height = Math.min(textInput.scrollHeight, 300) + 'px';
        };
        textInput.addEventListener('focus', renderCount);
        textInput.addEventListener('input', function(){ renderCount(); autoGrow(); });
        textInput.addEventListener('blur', function(){
            if(!textInput.value.length) charCountEl.textContent = '';
        });
    }

    var currentRating = 0;
    var locked = false;
    var stars = starsEl.querySelectorAll('.rw-star');
    var slug = CFG.slug;
    function csrfToken(){ var m=document.querySelector('meta[name="csrf-token"]'); return m?m.content:CFG.csrf; }
    var ERR_TOO_LONG = CFG.l10n.error_too_long;
    var ERR_RATE_LIMIT = CFG.l10n.error_rate_limit;
    var ERR_SESSION = CFG.l10n.error_session;
    var ERR_GENERIC = CFG.l10n.error;
    var CHARS_REMAINING = CFG.l10n.chars_remaining;
    var CMT_MAX = 2000;
    function parseError(r){
        if(r.status === 429) return Promise.resolve(ERR_RATE_LIMIT);
        if(r.status === 419) return Promise.resolve(ERR_SESSION);
        if(r.status === 422){
            return r.clone().json().then(function(d){
                if(d.errors){
                    var msgs = [];
                    Object.keys(d.errors).forEach(function(k){ msgs = msgs.concat(d.errors[k]); });
                    return msgs.join(' ');
                }
                return d.message || ERR_GENERIC;
            }).catch(function(){ return ERR_TOO_LONG.replace(':max', CMT_MAX); });
        }
        return Promise.resolve(ERR_GENERIC);
    }
    var storeUrl = CFG.routes.store;
    var checkUrl = CFG.routes.check;
    var commentUrl = CFG.routes.comment;
    var commentListUrl = CFG.routes.commentList;
    var commentRepliesUrl = CFG.routes.commentReplies;
    var labels = CFG.l10n.stars;
    var thankYouNew = CFG.l10n.thank_you;
    var thankYouUpdated = CFG.l10n.rating_updated;
    var pendingLabel = CFG.l10n.pending_badge;
    var postingAsLabel = CFG.l10n.posting_as;
    /* auth()->user() snapshot from the shim: {id, display_name, verified,
       is_pro, badge_html} for logged-in viewers, null for guests. */
    var currentUser = CFG.flags.currentUser || null;
    /* session('admin_logged_in') from the shim. */
    var isAdminSession = !!CFG.flags.isAdminSession;
    var adminPreviewUrl = CFG.routes.adminPreview;
    var mdLabels = {
        bold: CFG.l10n.md_bold,
        italic: CFG.l10n.md_italic,
        link: CFG.l10n.md_link,
        list: CFG.l10n.md_list,
        linkPrompt: CFG.l10n.md_link_text,
        linkPromptUrl: CFG.l10n.md_link_url,
        preview: CFG.l10n.md_preview
    };
    var justNowLabel = CFG.l10n.just_now;
    var editLabel = CFG.l10n.edit_comment;
    var saveLabel = CFG.l10n.save_comment;
    var cancelLabel = CFG.l10n.cancel_edit;
    var commentUpdatedLabel = CFG.l10n.comment_updated;
    var replyLabel = CFG.l10n.reply;
    var replyCancelLabel = CFG.l10n.feedback_cancel; /* __('tools.feedback.cancel') */
    var replyPlaceholder = CFG.l10n.reply_placeholder;
    /* view_more_replies_{1,2,few,many} — assembled server-side in the shim;
       locales missing a plural form simply omit the key (same filter the old
       inline @php block applied). */
    var replyForms = CFG.l10n.reply_forms || {};
    var nameLabel = CFG.l10n.name;
    var nameRequiredLabel = CFG.l10n.name_required;
    var likeLabel = CFG.l10n.like;
    var loadMoreLabel = CFG.l10n.load_more_comments;
    /* ── 3-dot menu (delete / report) ── */
    var menuLabel = CFG.l10n.comment_menu;
    var deleteLabel = CFG.l10n.delete_comment;
    var deleteConfirmLabel = CFG.l10n.delete_confirm;
    var deletedLabel = CFG.l10n.comment_deleted;
    var reportLabel = CFG.l10n.report;
    var reportTitleLabel = CFG.l10n.report_title;
    var reportNoteLabel = CFG.l10n.report_note;
    var reportSubmitLabel = CFG.l10n.report_submit;
    var reportThanksLabel = CFG.l10n.report_thanks;
    var reportChooseLabel = CFG.l10n.report_choose_reason;
    var reportReasons = {
        spam: CFG.l10n.report_reason_spam,
        offensive: CFG.l10n.report_reason_offensive,
        off_topic: CFG.l10n.report_reason_off_topic,
        other: CFG.l10n.report_reason_other
    };
    var commentDeleteUrl = CFG.routes.commentDelete;
    var commentReportUrl = CFG.routes.commentReport;
    var canModerate = isAdminSession || !!(currentUser && (currentUser.verified || currentUser.is_pro));
    var likeUrl = '/api/comment-like';
    var LIKE_LS_KEY = 'comment_likes';
    function getLikedIds(){ try { return JSON.parse(localStorage.getItem(LIKE_LS_KEY)) || []; } catch(e){ return []; } }
    function setLikedIds(arr){ localStorage.setItem(LIKE_LS_KEY, JSON.stringify(arr)); }
    function isLiked(id){ return getLikedIds().indexOf(id) !== -1; }
    function toggleLikedId(id){ var arr = getLikedIds(); var idx = arr.indexOf(id); if(idx !== -1) arr.splice(idx,1); else arr.push(id); setLikedIds(arr); }
    var HEART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>';
    var locale = CFG.locale;
    /* comments_count_{1,2,few,many} — assembled server-side in the shim (same
       missing-translation filter as reply_forms above). */
    var commentForms = CFG.l10n.comment_forms || {};
    var commentStatusUrl = CFG.routes.commentStatus;
    var commentUpdateUrl = CFG.routes.commentUpdate;
    var cmtsContainer = document.getElementById('rwCmts');
    var cmtsList = document.getElementById('rwCmtsList');
    var cmtsTitle = document.getElementById('rwCmtsTitle');
    var LS_KEY = 'timbrica_pending_comments';

    /* Pre-fill name from previous comment */
    var _savedName = localStorage.getItem('timbrica_cmt_name');
    if (_savedName && nameInput) nameInput.value = _savedName;

    /* ===== PLURALIZATION ===== */
    function pluralComments(n) {
        var f = commentForms;
        if (locale === 'ru') {
            var mod10 = n % 10, mod100 = n % 100;
            if (mod10 === 1 && mod100 !== 11) return (f.comments_count_1 || '').replace(':count', n);
            if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return (f.comments_count_few || '').replace(':count', n);
            return (f.comments_count_many || '').replace(':count', n);
        }
        if (locale === 'ar') {
            if (n === 0) return (f.comments_count_many || '').replace(':count', n);
            if (n === 1) return f.comments_count_1 || '';
            if (n === 2) return f.comments_count_2 || '';
            if (n >= 3 && n <= 10) return (f.comments_count_few || '').replace(':count', n);
            return (f.comments_count_many || '').replace(':count', n);
        }
        /* en, ko, id — simple */
        if (n === 1) return (f.comments_count_1 || '').replace(':count', n);
        return (f.comments_count_many || '').replace(':count', n);
    }

    function pluralReplies(n) {
        var f = replyForms;
        if (locale === 'ru') {
            var mod10 = n % 10, mod100 = n % 100;
            if (mod10 === 1 && mod100 !== 11) return (f.view_more_replies_1 || '').replace(':count', n);
            if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return (f.view_more_replies_few || '').replace(':count', n);
            return (f.view_more_replies_many || '').replace(':count', n);
        }
        if (locale === 'ar') {
            if (n === 1) return (f.view_more_replies_1 || '').replace(':count', n);
            if (n === 2) return f.view_more_replies_2 || '';
            if (n >= 3 && n <= 10) return (f.view_more_replies_few || '').replace(':count', n);
            return (f.view_more_replies_many || '').replace(':count', n);
        }
        /* en, ko, id — simple */
        if (n === 1) return (f.view_more_replies_1 || '').replace(':count', n);
        return (f.view_more_replies_many || '').replace(':count', n);
    }

    /* ===== FIELD VALIDATION FLASH ===== */
    function flashRequired(el) {
        el.style.borderColor = 'var(--danger)';
        el.focus();
        setTimeout(function(){ el.style.borderColor = ''; }, 2000);
    }

    /* ===== AVATAR SYSTEM ===== */
    var AVATARS = [
        '\uD83D\uDE0E','\uD83E\uDD13','\uD83D\uDE0A','\uD83E\uDD29',
        '\uD83E\uDD16','\uD83D\uDC7B','\uD83D\uDC31','\uD83D\uDC3B',
        '\uD83D\uDC28','\uD83E\uDD8A','\uD83D\uDC36','\uD83D\uDC25',
        '\uD83D\uDC27','\uD83E\uDD89','\uD83E\uDD84','\uD83D\uDC1D',
        '\uD83C\uDF1F','\uD83C\uDF08','\uD83D\uDD25','\uD83C\uDF3B',
        '\uD83C\uDF3A','\uD83C\uDF38','\uD83C\uDF40','\uD83C\uDF1E'
    ];
    var AVATAR_COLORS = [
        '#ef4444','#f97316','#eab308','#22c55e','#06b6d4','#3b82f6',
        '#8b5cf6','#ec4899','#14b8a6','#f43f5e','#a855f7','#6366f1'
    ];

    function hashStr(s){
        var h = 0;
        for(var i = 0; i < s.length; i++){
            h = ((h << 5) - h) + s.charCodeAt(i);
            h = h & h;
        }
        return Math.abs(h);
    }

    function getAvatar(name){
        var h = hashStr(name);
        return AVATARS[h % AVATARS.length];
    }

    function getAvatarColor(name){
        var h = hashStr(name + '_clr');
        return AVATAR_COLORS[h % AVATAR_COLORS.length];
    }

    function makeStarsHtml(rating){
        if(!rating) return '';
        var html = '<span class="rw-cmt-stars">';
        for(var i = 1; i <= 5; i++){
            html += '<svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" class="'+(i<=rating?'sf':'se')+'"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
        }
        html += '</span>';
        return html;
    }

    function escHtml(s) { return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    /* Admin-only markdown editor: loaded lazily the first time admin opens a reply form */
    var _mdPromise = null;
    function loadAdminMarkdown(){
        if (window.AdminMarkdown) return Promise.resolve(window.AdminMarkdown);
        if (_mdPromise) return _mdPromise;
        _mdPromise = new Promise(function(resolve, reject){
            var s = document.createElement('script');
            s.src = '/js/admin-markdown.js?v=2'; // v=2: shouldPreview/postProcess hooks + stale-response guard
            s.async = true;
            s.onload = function(){ resolve(window.AdminMarkdown); };
            s.onerror = function(){ _mdPromise = null; reject(new Error('admin-markdown failed')); };
            document.head.appendChild(s);
        });
        return _mdPromise;
    }
    function maybeMountAdminEditor(form){
        if (!isAdminSession) return;
        if (form.dataset.mdMounted === '1') return;
        var ta = form.querySelector('textarea');
        var preview = form.querySelector('.md-preview');
        if (!ta || !preview) return;
        form.dataset.mdMounted = '1';
        loadAdminMarkdown().then(function(mod){
            if (!mod) return;
            mod.mount(ta, {
                previewEl: preview,
                previewUrl: adminPreviewUrl,
                csrfToken: csrfToken(),
                labels: mdLabels,
                /* Preview must match how the POSTED reply will render:
                   style the «@Имя» prefix the same way. */
                postProcess: mentionizeAdminHtml,
                /* A body that is ONLY the reply prefill («@Имя ») has nothing
                   to preview — don't render a grey box duplicating the
                   textarea under the form. */
                shouldPreview: function(body){
                    var m = renderMentionPrefix(body.trim());
                    return !(m && m.rest.trim() === '');
                }
            });
        }).catch(function(){ /* silent */ });
    }

    /* DOMPurify lazy loader — only fetched when an admin comment is rendered */
    var _dpPromise = null;
    function loadDOMPurify(){
        if (window.DOMPurify) return Promise.resolve(window.DOMPurify);
        if (_dpPromise) return _dpPromise;
        _dpPromise = new Promise(function(resolve, reject){
            var s = document.createElement('script');
            s.src = '/vendor/dompurify/purify.min.js';
            s.async = true;
            s.onload = function(){ resolve(window.DOMPurify); };
            s.onerror = function(){ _dpPromise = null; reject(new Error('DOMPurify load failed')); };
            document.head.appendChild(s);
        });
        return _dpPromise;
    }
    function ensureSanitizerFor(list){
        var needs = list.some(function(c){
            return (c && c.is_admin && c.comment_html) || (c && c.last_reply && c.last_reply.is_admin && c.last_reply.comment_html);
        });
        if (!needs || window.DOMPurify) return Promise.resolve();
        return loadDOMPurify().catch(function(){ return null; });
    }

    /* Safe plain-text → HTML: the shared __linkifyUserText primitive
       (timbrica-core.js) builds text nodes + anchors in a detached span
       (XSS-safe by construction — serialization escapes everything), then
       \n → <br>. Own-site links keep weight (rel=noopener); foreign URLs get
       rel="ugc nofollow noopener noreferrer" — ONE policy site-wide, and bare
       timbrica/tembrica.com links are clickable too.
       Takes RAW text (it escapes itself), unlike the old escHtml pipeline. */
    function linkifyAndBreak(rawText){
        var span = document.createElement('span');
        if (window.__linkifyUserText) span.appendChild(window.__linkifyUserText(rawText));
        else span.textContent = rawText == null ? '' : String(rawText);
        return span.innerHTML.replace(/\n/g, '<br>');
    }

    /* ===== @MENTION RENDERING (Instagram-style) =====
       Replies store a literal "@Имя " prefix (the reply form pre-fills it).
       Render it as the person's name — accent profile link for registered
       authors, bold plain name for anonymous. Only names actually seen in
       this page's threads are matched (directory below), so arbitrary
       @-text is never mangled. Mirrors $rwRenderBody on the SSR side. */
    var authorDirectory = CFG.authors || {}; /* SSR $ssrAuthorMap roster from the shim */
    function registerAuthor(c){
        if (c && c.author_name && !(c.author_name in authorDirectory)) {
            authorDirectory[c.author_name] = c.username || null;
        }
    }
    function mentionBoundary(ch){
        return ch === '' || /[\s,.:;!?…)]/.test(ch);
    }
    function mentionHtmlFor(name){
        var uname = authorDirectory[name];
        return uname
            ? '<a class="rw-mention" href="/u/' + encodeURIComponent(uname) + '">' + escHtml(name) + '</a>'
            : '<span class="rw-mention">' + escHtml(name) + '</span>';
    }
    /* Plain-text path: raw comment starting with "@KnownName". Longest
       known name wins (handles "Иван" vs "Иван Петров"). */
    function renderMentionPrefix(rawText){
        if (!rawText || rawText.charAt(0) !== '@') return null;
        var best = null;
        for (var name in authorDirectory) {
            if (rawText.substr(1, name.length) === name
                && mentionBoundary(rawText.charAt(1 + name.length))
                && (!best || name.length > best.length)) best = name;
        }
        if (!best) return null;
        return { html: mentionHtmlFor(best), rest: rawText.slice(1 + best.length) };
    }
    /* Admin path: sanitized comment_html, typically "<p>@Имя ...". The
       Symfony HtmlSanitizer entity-encodes '@' as "&#64;" (also possible:
       "&#x40;", "&commat;", or a literal '@' from other renderers), so match
       every form. Names are compared in their escaped form since the
       surrounding HTML is entity-encoded. */
    var AT_TOKEN_RE = /^(@|&#0*64;|&#[xX]0*40;|&commat;)/;
    function mentionizeAdminHtml(html){
        var m = html.match(/^(\s*<p(?:\s[^>]*)?>)(@|&#0*64;|&#[xX]0*40;|&commat;)/);
        if (!m) return html;
        var pOpen = m[1];
        var atToken = m[2];
        var at = pOpen.length + atToken.length; // index just past the '@' token
        var best = null, bestEsc = null;
        for (var name in authorDirectory) {
            var esc = escHtml(name);
            if (html.substr(at, esc.length) === esc) {
                var after = html.charAt(at + esc.length);
                if ((after === '<' || after === '&' || mentionBoundary(after))
                    && (!bestEsc || esc.length > bestEsc.length)) { best = name; bestEsc = esc; }
            }
        }
        if (!best) return html;
        return pOpen + mentionHtmlFor(best) + html.substring(at + bestEsc.length);
    }
    var DP_CFG = {
        ALLOWED_TAGS: ['p','strong','em','br','ul','ol','li','a'],
        ALLOWED_ATTR: ['href','title','rel','target'],
        ALLOW_DATA_ATTR: false
    };
    function renderCommentBody(c){
        if (c && c.is_admin && c.comment_html && window.DOMPurify) {
            return mentionizeAdminHtml(window.DOMPurify.sanitize(c.comment_html, DP_CFG));
        }
        var raw = (c && c.comment) ? c.comment : '';
        var m = renderMentionPrefix(raw);
        if (m) return m.html + linkifyAndBreak(m.rest);
        return linkifyAndBreak(raw);
    }
    /* Author status badge — server-rendered by App\Support\UserBadge and shipped
       as `badge_html` in the API payload (RatingController::formatCommentEntry),
       so SSR and AJAX badges are byte-identical. The client never builds badge
       markup itself — that drift is exactly what this refactor removed. */
    function renderAuthorBadges(c){
        return (c && c.badge_html) ? c.badge_html : '';
    }

    // Real avatar for "real" accounts only — the server already nulls
    // avatar_url/avatar_emoji for anonymous/unverified authors, so presence == show.
    function cmtHasAvatar(c){ return !!(c && (c.avatar_url || c.avatar_emoji)); }
    function cmtAvatarHtml(c){
        if (!cmtHasAvatar(c)) return '';
        var inner;
        if (c.avatar_url) {
            /* Animated avatars (paid perk) are .webm — an <img> can't decode
               video, so mirror the x-user-avatar Blade component: a muted
               looping micro-video. Strip ?v= before the extension sniff.
               ⚠️ This function REPLACES the server-rendered list on hydration, so
               anything the Blade component does must be repeated here or it is
               undone a second after the page loads. That is how the "portrait at
               rest" markup (data-hp-avatar + poster, no autoplay) went missing on
               the very first run of avatar-portrait-at-rest.mjs. */
            var clean = String(c.avatar_url).split('?')[0];
            var isWebm = /\.webm$/i.test(clean);
            var isGif  = /\.gif$/i.test(clean);
            var m = /^\/storage\/avatars\/u(\d+)\./.exec(clean);
            // ⚠️ Carry the ?v= across. /storage is served `immutable` for a
            // YEAR and the poster path never changes, so an unversioned URL
            // pins the PREVIOUS still frame in every reader's browser — and the
            // still frame IS the avatar in a comment list. Same reasoning as the
            // Blade component; it has to be repeated here because this function
            // replaces the server-rendered list.
            var vm = /[?&]v=([A-Za-z0-9]+)/.exec(String(c.avatar_url));
            var poster = (m && (isWebm || isGif))
                ? '/storage/avatars/u' + m[1] + '.poster.webp' + (vm ? '?v=' + vm[1] : '')
                : '';
            // f=1 — measured past the WCAG flash threshold at upload. Frozen for
            // everyone, no hover, no fallback to the animated file.
            var flashing = /[?&]f=1(&|$)/.test(String(c.avatar_url));
            var needsAlpha = /[?&]a=1(&|$)/.test(String(c.avatar_url));
            if (flashing && poster) {
                inner = '<img src="' + escHtml(poster) + '" alt="" loading="lazy"'
                      + ' onerror="this.style.display=\'none\'">';
            } else if (isWebm) {
                inner = '<video data-hp-avatar="video"' + (needsAlpha ? ' data-hp-alpha="1"' : '')
                      + ' loop muted playsinline preload="metadata"'
                      + (poster ? ' poster="' + escHtml(poster) + '"' : '')
                      + '><source src="' + escHtml(c.avatar_url) + '" type="video/webm"></video>';
            } else if (isGif && poster) {
                inner = '<img data-hp-avatar="gif" src="' + escHtml(poster) + '" data-hp-src="'
                      + escHtml(c.avatar_url) + '" alt="" loading="lazy"'
                      + ' onerror="if(this.src!==this.dataset.hpSrc){this.onerror=null;this.src=this.dataset.hpSrc;}">';
            } else {
                inner = '<img src="' + escHtml(c.avatar_url) + '" alt="" loading="lazy">';
            }
        } else {
            inner = escHtml(c.avatar_emoji);
        }
        return '<div class="rw-cmt-avatar">' + inner + '</div>';
    }

    /* ===== 3-DOT MENU (delete / report) ===== */
    var DOTS_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>';
    var TRASH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
    var PENCIL_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>';
    var FLAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>';

    /* Who sees the kebab on a given comment:
       - admin  → every comment (delete + report-on-non-admin)
       - Pro / verified → only NON-admin comments (report)
       - everyone else → never */
    function menuVisibleFor(c){
        if (isAdminSession) return true;
        if (currentUser && (currentUser.verified || currentUser.is_pro)) return !c.is_admin;
        return false;
    }
    function cmtMenuHtml(c){
        if (!menuVisibleFor(c)) return '';
        return '<div class="rw-menu"><button type="button" class="rw-menu-btn" data-menu="' + c.id + '" data-admin-cmt="' + (c.is_admin ? '1' : '0') + '" aria-label="' + escHtml(menuLabel) + '" aria-haspopup="true" aria-expanded="false">' + DOTS_SVG + '</button></div>';
    }

    /* ===== BUILD COMMENT HTML ===== */
    function buildCommentHtml(c, isPending){
        registerAuthor(c);
        if (c && c.last_reply) registerAuthor(c.last_reply);
        /* Two pending flavours: isPending = just-posted localStorage card (edit
           affordance, "just now"); c.is_pending = the SERVER returned the viewer's
           own on-moderation comment (real date, real reply thread under it —
           that's where an approved admin reply lives). Both show the badge. */
        var srvPending = !isPending && !!c.is_pending;
        var anyPending = isPending || srvPending;
        var emoji = getAvatar(c.author_name);
        var color = getAvatarColor(c.author_name);
        var starsHtml = c.rating ? makeStarsHtml(c.rating) : '';
        var adminBadgeHtml = renderAuthorBadges(c);
        var badgeHtml = anyPending ? '<span class="rw-cmt-badge">' + pendingLabel + '</span>' : '';
        var dateText = isPending ? justNowLabel : (c.time_ago || '');

        var likesCount = c.likes_count || 0;
        var liked = isLiked(c.id);
        var likeHtml = anyPending ? '' : '<button type="button" class="rw-like-btn' + (liked ? ' liked' : '') + '" data-like="' + c.id + '" aria-label="' + escHtml(likeLabel) + '">' + HEART_SVG + '<span class="rw-like-count">' + (likesCount > 0 ? likesCount : '') + '</span></button>';

        var actionsHtml = '<div class="rw-cmt-actions">';
        if(isPending){
            actionsHtml += '<button type="button" class="rw-cmt-edit-btn" data-edit-pending="' + c.id + '">' + editLabel + '</button>';
        } else {
            actionsHtml += '<button type="button" class="rw-cmt-reply-btn" data-reply="' + c.id + '">' + replyLabel + '</button>';
            actionsHtml += likeHtml;
        }
        actionsHtml += '</div>';

        var replyNameField;
        if (currentUser) {
            replyNameField = '<div class="rw-posting-as rw-posting-as-sm">'
                + '<span class="rw-posting-label">' + escHtml(postingAsLabel) + '</span>'
                + '<span class="rw-posting-name">' + escHtml(currentUser.display_name) + '</span>'
                + (currentUser.badge_html || '')
                + '</div>';
        } else {
            replyNameField = '<input type="text" placeholder="' + escHtml(nameLabel) + '" maxlength="100" autocomplete="name">';
        }
        var replyTaId = 'rwReplyText_' + c.id;
        var emojiLabel = (window.__EMOJI_PICKER_T && window.__EMOJI_PICKER_T.button_label) || 'Insert emoji';
        var emojiBtnHtml = '<button type="button" class="ep-trigger rw-emoji-btn" data-emoji-picker="' + replyTaId + '" data-emoji-source="rating_reply" data-size="sm" aria-label="' + escHtml(emojiLabel) + '" title="' + escHtml(emojiLabel) + '" aria-haspopup="dialog" aria-expanded="false">☺️</button>';
        var replyFormHtml = '<div class="rw-reply-form" id="rwReplyForm_' + c.id + '"' + (currentUser ? ' data-authed="1"' : '') + '>'
            + replyNameField
            + '<textarea id="' + replyTaId + '" placeholder="' + escHtml(replyPlaceholder) + '" maxlength="2000" rows="3"></textarea>'
            + '<div class="md-preview" hidden></div>'
            + '<div class="rw-reply-btns">'
            + emojiBtnHtml
            + '<button type="button" data-send-reply="' + c.id + '">' + replyLabel + '</button>'
            + '<button type="button" class="rw-reply-cancel" data-cancel-reply="' + c.id + '">' + replyCancelLabel + '</button>'
            + '</div>'
            + '</div>';

        var repliesHtml = '';
        if(c.reply_count > 0 && c.last_reply){
            var hiddenCount = c.reply_count - 1;
            if(hiddenCount > 0){
                var label = pluralReplies(hiddenCount);
                repliesHtml += '<button type="button" class="rw-view-replies" data-load-replies="' + c.id + '">'
                    + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>'
                    + label
                    + '</button>';
            }
            repliesHtml += '<div class="rw-replies" id="rwReplies_' + c.id + '">'
                + '<div class="rw-last-reply" id="rwLastReply_' + c.id + '">' + buildReplyHtml(c.last_reply, c.id) + '</div>'
                + '</div>';
        } else {
            repliesHtml = '<div class="rw-replies" id="rwReplies_' + c.id + '" hidden></div>';
        }

        var rootClass = 'rw-cmt' + (isPending ? ' rw-cmt-new' : '') + (c.is_admin ? ' rw-cmt-admin' : '') + (cmtHasAvatar(c) ? ' rw-cmt--av' : '');
        var bodyTag = (c.is_admin && c.comment_html) ? 'div' : 'p';
        // Admin cards carry the raw markdown source (URI-encoded → attr-safe) so
        // the admin inline editor can prefill from the DOM without a round-trip.
        var mdAttr = c.is_admin ? ' data-md="' + encodeURIComponent(c.comment || '') + '"' : '';
        return '<div class="' + rootClass + '"' + (anyPending ? ' data-pending="1"' : '') + ' data-cid="' + c.id + '"' + mdAttr + ' id="' + (isPending ? ('rwPendingCmt_' + c.id) : ('cid-' + c.id)) + '">'
            + '<div class="rw-cmt-head">'
            + cmtAvatarHtml(c)
            + '<div class="rw-cmt-info">'
            + '<div class="rw-cmt-name-row">'
            + (c.username ? '<a class="rw-cmt-author" href="/u/' + encodeURIComponent(c.username) + '" style="text-decoration:none;color:var(--accent)">' + escHtml(c.author_name) + '</a>' : '<span class="rw-cmt-author">' + escHtml(c.author_name) + '</span>')
            + adminBadgeHtml + starsHtml + badgeHtml
            + '<span class="rw-cmt-date">' + escHtml(dateText) + '</span>'
            + '</div>'
            + '</div>'
            + (isPending ? '' : cmtMenuHtml(c))
            + '</div>'
            + '<' + bodyTag + ' class="rw-cmt-text">' + renderCommentBody(c) + '</' + bodyTag + '>'
            + actionsHtml
            + replyFormHtml
            + repliesHtml
            + '</div>';
    }

    function buildReplyHtml(r, topParentId, isPending){
        registerAuthor(r);
        var emoji = getAvatar(r.author_name);
        var color = getAvatarColor(r.author_name);
        var pid = topParentId || r.id;
        var rLikes = r.likes_count || 0;
        var rLiked = isLiked(r.id);
        var rLikeHtml = '<button type="button" class="rw-like-btn' + (rLiked ? ' liked' : '') + '" data-like="' + r.id + '" aria-label="' + escHtml(likeLabel) + '">' + HEART_SVG + '<span class="rw-like-count">' + (rLikes > 0 ? rLikes : '') + '</span></button>';
        var rAdminBadge = renderAuthorBadges(r);
        /* Pending replies mirror the pending top-level card: amber badge,
           "just now" date, and NO reply/like buttons — a non-admin reply is
           status=pending on the server (approved-only reads won't return it),
           so rendering it as a live published reply would be lying. */
        var rBadgeHtml = isPending ? '<span class="rw-cmt-badge">' + pendingLabel + '</span>' : '';
        var rDateText = isPending ? justNowLabel : (r.time_ago || '');
        var rActionsHtml = isPending ? '' : '<div class="rw-cmt-actions"><button type="button" class="rw-cmt-reply-btn" data-reply="' + pid + '" data-mention="' + escHtml(r.author_name) + '">' + replyLabel + '</button>' + rLikeHtml + '</div>';
        var rootClass = 'rw-cmt' + (isPending ? ' rw-cmt-new' : '') + (r.is_admin ? ' rw-cmt-admin' : '') + (cmtHasAvatar(r) ? ' rw-cmt--av' : '');
        var bodyTag = (r.is_admin && r.comment_html) ? 'div' : 'p';
        var rMdAttr = r.is_admin ? ' data-md="' + encodeURIComponent(r.comment || '') + '"' : '';
        return '<div class="' + rootClass + '" data-cid="' + r.id + '"' + rMdAttr + ' id="cid-' + r.id + '">'
            + '<div class="rw-cmt-head">'
            + cmtAvatarHtml(r)
            + '<div class="rw-cmt-info">'
            + '<div class="rw-cmt-name-row">' + (r.username ? '<a class="rw-cmt-author" href="/u/' + encodeURIComponent(r.username) + '" style="text-decoration:none;color:var(--accent)">' + escHtml(r.author_name) + '</a>' : '<span class="rw-cmt-author">' + escHtml(r.author_name) + '</span>') + rAdminBadge + rBadgeHtml + '<span class="rw-cmt-date">' + escHtml(rDateText) + '</span></div>'
            + '</div>'
            + (isPending ? '' : cmtMenuHtml(r))
            + '</div>'
            + '<' + bodyTag + ' class="rw-cmt-text">' + renderCommentBody(r) + '</' + bodyTag + '>'
            + rActionsHtml
            + '</div>';
    }

    /* ===== AJAX LOAD COMMENTS ===== */
    var totalCommentCount = 0;
    var loadMoreBtn = null;

    function loadComments(offset){
        offset = offset || 0;
        var url = commentListUrl + '?tool_slug=' + encodeURIComponent(slug);
        if(offset) url += '&offset=' + offset;

        fetch(url)
            .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data){
                var comments = data.comments || [];
                return ensureSanitizerFor(comments).then(function(){
                    return { comments: comments, authors: data.authors, has_more: data.has_more, next_offset: data.offset };
                });
            })
            .then(function(data){
                var comments = data.comments || [];
                var hasMore = data.has_more || false;
                var isFirstPage = !offset;

                if(isFirstPage && comments.length === 0 && !getMyPendingTops().length){
                    cmtsContainer.hidden = true;
                    return;
                }
                cmtsContainer.hidden = false;

                var html = '';
                /* Register every author BEFORE building HTML so a reply can
                   mention any participant of the batch, not just those
                   rendered earlier in the loop. data.authors is the server's
                   full thread roster (covers authors whose replies aren't in
                   this collapsed payload). */
                var roster = data.authors || {};
                for (var rn in roster) {
                    if (!(rn in authorDirectory)) authorDirectory[rn] = roster[rn];
                }
                comments.forEach(function(c){
                    registerAuthor(c);
                    if (c.last_reply) registerAuthor(c.last_reply);
                });
                comments.forEach(function(c){
                    html += buildCommentHtml(c, false);
                });

                if(isFirstPage){
                    totalCommentCount = comments.length;
                    /* The viewer's own on-moderation comments, straight from the
                       server — visible on ANY device, with the real (approved)
                       reply thread under them. This is what makes a "someone
                       replied to you" notification land on the actual thread
                       instead of an empty page while the parent awaits review. */
                    var pendHtml = '';
                    (data.own_pending || []).forEach(function(c){
                        registerAuthor(c);
                        if (c.last_reply) registerAuthor(c.last_reply);
                        pendHtml += buildCommentHtml(c, false);
                        totalCommentCount++;
                    });
                    cmtsList.innerHTML = pendHtml + html;
                    /* This list replaces the server-rendered one, so anything the
                       Blade component arranged has to be re-arranged here: the
                       transparent-avatar guard may not have found a candidate at
                       load time and would otherwise never look again. */
                    if (window.__hpAvatarsRefresh) window.__hpAvatarsRefresh();

                    /* Re-inject own pending top-level comments if any exist
                       (server list is approved-only, so they'd vanish otherwise) */
                    getMyPendingTops().forEach(function(pending){
                        var alreadyRendered = cmtsList.querySelector('[data-cid="' + pending.id + '"]');
                        if(alreadyRendered && alreadyRendered.hasAttribute('data-pending')){
                            /* The server already rendered this one as still-pending —
                               keep the localStorage entry (it powers local edit +
                               status polling), just don't render a duplicate. */
                            return;
                        }
                        if(alreadyRendered){
                            /* Approved copy came back from the server — drop the local one */
                            removePendingComment(pending.id);
                        } else {
                            totalCommentCount++;
                            cmtsList.insertAdjacentHTML('afterbegin', buildCommentHtml({
                                id: pending.id,
                                author_name: pending.author_name,
                                comment: pending.comment,
                                rating: null,
                                reply_count: 0
                            }, true));
                        }
                    });
                } else {
                    totalCommentCount += comments.length;
                    cmtsList.insertAdjacentHTML('beforeend', html);
                }

                /* Re-inject own pending replies into their parents' reply
                   containers (both first page and load-more batches may have
                   just rendered a parent) */
                injectPendingReplies();

                cmtsTitle.textContent = pluralComments(totalCommentCount);

                /* "Load more" button */
                if(loadMoreBtn) loadMoreBtn.remove();
                if(hasMore && comments.length > 0){
                    var nextOffset = (typeof data.next_offset === 'number') ? data.next_offset : (offset + comments.length);
                    loadMoreBtn = document.createElement('button');
                    loadMoreBtn.type = 'button';
                    loadMoreBtn.className = 'rw-load-more-btn';
                    loadMoreBtn.textContent = loadMoreLabel;
                    loadMoreBtn.addEventListener('click', function(){
                        loadMoreBtn.disabled = true;
                        loadMoreBtn.textContent = '...';
                        loadComments(nextOffset);
                    });
                    cmtsList.after(loadMoreBtn);
                }
            })
            .catch(function(){
                if(!offset){
                    /* Fallback: show own pending comments from localStorage */
                    var tops = getMyPendingTops();
                    if(tops.length){
                        cmtsContainer.hidden = false;
                        var fallbackHtml = '';
                        tops.forEach(function(pending){
                            fallbackHtml += buildCommentHtml({
                                id: pending.id,
                                author_name: pending.author_name,
                                comment: pending.comment,
                                rating: null,
                                reply_count: 0
                            }, true);
                        });
                        cmtsList.innerHTML = fallbackHtml;
                    }
                }
            });
    }

    /* ===== LOAD REPLIES (chronological — oldest → newest, like YouTube/Instagram threads) ===== */
    function loadReplies(commentId, btn, offset){
        offset = offset || 0;
        var repliesContainer = document.getElementById('rwReplies_' + commentId);
        if(!repliesContainer) return;

        var url = commentRepliesUrl + '?comment_id=' + encodeURIComponent(commentId);
        if(offset) url += '&offset=' + offset;

        if(btn){
            btn.disabled = true;
            btn.textContent = '...';
        }

        fetch(url)
            .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data){
                var replies = data.replies || [];
                return ensureSanitizerFor(replies).then(function(){
                    return { replies: replies, has_more: data.has_more, next_offset: data.offset };
                });
            })
            .then(function(data){
                var replies = data.replies || [];
                var hasMore = data.has_more || false;
                var isFirstPage = !offset;

                var html = '';
                replies.forEach(registerAuthor); // all authors known before any body renders
                replies.forEach(function(r){ html += buildReplyHtml(r, commentId); });

                if(isFirstPage){
                    /* First load: replace best-reply preview with full batch.
                       GUARD an open reply form first. Clicking "Reply" on a
                       reply relocates the single rwReplyForm_<id> INTO this
                       thread (actions.after(form)) — often inside the
                       rwLastReply preview. Removing the preview or resetting
                       innerHTML would destroy that live node: it wipes the text
                       the user is typing AND orphans every rebuilt reply's
                       Reply button (they target the now-missing form id, so the
                       click no-ops — the "field gone + button dead" report).
                       Detach the node first (keeps its textarea value + any
                       mounted admin editor / emoji binding), rebuild, re-attach. */
                    var openForm = document.getElementById('rwReplyForm_' + commentId);
                    var keepForm = (openForm && repliesContainer.contains(openForm)) ? openForm : null;
                    if(keepForm) keepForm.remove();

                    var lastReplyEl = document.getElementById('rwLastReply_' + commentId);
                    if(lastReplyEl) lastReplyEl.remove();
                    repliesContainer.innerHTML = html;
                    if(keepForm) repliesContainer.appendChild(keepForm);
                } else {
                    /* Loading more: append after existing replies (same order as page) */
                    repliesContainer.insertAdjacentHTML('beforeend', html);
                }
                repliesContainer.removeAttribute('hidden');

                /* The rebuild/append above renders approved replies only —
                   put the viewer's own pending replies back (and drop the
                   local copy when an approved twin just arrived). */
                injectPendingReplies(commentId);

                /* Remove old button */
                if(btn) btn.remove();

                /* Add "load more" button if more exist */
                if(hasMore && replies.length > 0){
                    var nextOffset = (typeof data.next_offset === 'number') ? data.next_offset : (offset + replies.length);
                    var moreBtn = document.createElement('button');
                    moreBtn.type = 'button';
                    moreBtn.className = 'rw-view-replies';
                    moreBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>' + pluralReplies(10);
                    moreBtn.addEventListener('click', function(){
                        loadReplies(commentId, moreBtn, nextOffset);
                    });
                    repliesContainer.after(moreBtn);
                }
            })
            .catch(function(){
                if(btn){ btn.disabled = false; btn.textContent = ''; }
            });
    }

    /* ===== AUTO-GROW REPLY TEXTAREA ===== */
    cmtsList.addEventListener('input', function(e){
        if(e.target.tagName === 'TEXTAREA'){
            e.target.style.height = 'auto';
            e.target.style.height = Math.min(e.target.scrollHeight, 300) + 'px';
        }
    });

    /* ===== EVENT DELEGATION FOR COMMENTS ===== */
    cmtsList.addEventListener('click', function(e){
        /* 3-dot menu toggle */
        var menuBtn = e.target.closest('[data-menu]');
        if(menuBtn){
            toggleCommentMenu(menuBtn);
            return;
        }

        /* Reply button */
        var replyBtn = e.target.closest('[data-reply]');
        if(replyBtn){
            var cid = replyBtn.getAttribute('data-reply');
            var mention = replyBtn.getAttribute('data-mention');
            var form = document.getElementById('rwReplyForm_' + cid);
            if(form){
                /* A single reply form is shared per thread (rwReplyForm_<topId>)
                   and moved next to whichever comment is being replied to. The
                   click means one of:
                     (a) SAME comment, form already open → user cancels (hide);
                     (b) DIFFERENT comment (or form closed) → move here, open,
                         and re-prefill for THIS author.
                   The old code used a blind toggle(), so clicking a different
                   comment's «Ответить» while the form was open just hid it AND
                   left the previous author's text/preview behind — the stale
                   «@Верховный» under an empty box in the bug report. */
                var clickedComment = replyBtn.closest('.rw-cmt');
                var actions = clickedComment ? clickedComment.querySelector('.rw-cmt-actions') : null;
                var wasAdjacent = actions && actions.nextElementSibling === form;
                var isOpen = form.classList.contains('show');

                if(isOpen && wasAdjacent){
                    /* (a) toggle closed */
                    form.classList.remove('show');
                    var taClose = form.querySelector('textarea');
                    if(taClose){ taClose.value = ''; taClose.dispatchEvent(new Event('input', { bubbles: true })); }
                    return;
                }

                /* (b) (re)open under the clicked comment */
                if(actions && !wasAdjacent) actions.after(form);
                form.classList.add('show');

                /* Authenticated reply forms render <div class="rw-posting-as">,
                 * not an <input>, so querySelector('input') returns null.
                 * savedName is populated only by guest comments — restore it. */
                var savedName = localStorage.getItem('timbrica_cmt_name');
                if(savedName){
                    var nameInput = form.querySelector('input');
                    if(nameInput) nameInput.value = savedName;
                }
                var ta = form.querySelector('textarea');
                ta.value = mention ? '@' + mention + ' ' : '';
                /* Programmatic value set fires no 'input', so the admin markdown
                   live-preview would keep STALE content from the previous open.
                   Dispatch it so the preview re-renders (or clears when empty). */
                ta.dispatchEvent(new Event('input', { bubbles: true }));
                ta.focus();
                maybeMountAdminEditor(form);
            }
            return;
        }

        /* Cancel reply */
        var cancelBtn = e.target.closest('[data-cancel-reply]');
        if(cancelBtn){
            var cid = cancelBtn.getAttribute('data-cancel-reply');
            var form = document.getElementById('rwReplyForm_' + cid);
            if(form){
                form.classList.remove('show');
                form.querySelector('textarea').value = '';
            }
            return;
        }

        /* Send reply */
        var sendBtn = e.target.closest('[data-send-reply]');
        if(sendBtn){
            var parentId = sendBtn.getAttribute('data-send-reply');
            var form = document.getElementById('rwReplyForm_' + parentId);
            if(!form) return;
            var authed = form.getAttribute('data-authed') === '1';
            var nameInput2 = authed ? null : form.querySelector('input');
            var textInput2 = form.querySelector('textarea');
            var name;
            if (authed && currentUser) {
                name = currentUser.display_name || '';
            } else {
                if (!nameInput2) return;
                name = nameInput2.value.trim();
                if(!name){ flashRequired(nameInput2); if(window.__toast) window.__toast(nameRequiredLabel,'warning'); return; }
            }
            var text = textInput2.value.trim();
            if(!text){ flashRequired(textInput2); return; }

            sendBtn.disabled = true;
            if (!authed) localStorage.setItem('timbrica_cmt_name', name);

            var fd = new FormData();
            fd.append('_token', csrfToken());
            fd.append('tool_slug', slug);
            fd.append('author_name', name);
            fd.append('comment', text);
            fd.append('parent_id', parentId);

            // Loading state — pre-fix the form stayed open for the
            // POST round-trip (~500 ms) AND admin path waited for a
            // second GET /rate/replies (~1-2 s more) before the new
            // comment surfaced, so the admin saw the form just sit
            // there. Adding .is-loading lights up a spinner via CSS
            // (rw-reply-form button[data-send-reply].is-loading) so
            // the user knows their click landed.
            sendBtn.classList.add('is-loading');

            fetch(commentUrl, { method: 'POST', body: fd })
                .then(function(r){
                    if(!r.ok) return parseError(r).then(function(msg){ throw new Error(msg); });
                    return r.json();
                })
                .then(function(data){
                    if(data.success){
                        if (nameInput2) nameInput2.value = '';
                        textInput2.value = '';
                        textInput2.style.height = '';
                        form.classList.remove('show');

                        // Both paths now insert from the server's
                        // formatted reply payload — no second GET
                        // round-trip. The backend renders comment_html
                        // for admin replies on the POST itself, and
                        // returns the same shape commentReplies()
                        // would have produced. buildReplyHtml() reads
                        // is_admin + comment_html and picks the right
                        // body tag / DOMPurify sanitize.
                        var repliesContainer = document.getElementById('rwReplies_' + parentId);
                        var fallback = {
                            id: data.comment_id,
                            author_name: name,
                            comment: text,
                            time_ago: justNowLabel,
                            is_admin: !!data.is_admin
                        };
                        var entry = data.reply || fallback;
                        // Server truth: only admin replies are auto-approved
                        // (status='approved'); everyone else's reply is
                        // created status='pending' and won't come back from
                        // the approved-only read endpoints. Render it as
                        // pending (badge, no like/reply buttons) and persist
                        // it locally so it survives a reload.
                        var isPendingReply = !data.is_admin;
                        if(isPendingReply){
                            savePendingComment(data.comment_id, name, text, parseInt(parentId, 10));
                        }
                        // Pre-load DOMPurify if the entry needs it
                        // (only for admin rich HTML). For non-admin
                        // ensureSanitizerFor is a no-op fast path.
                        ensureSanitizerFor([entry]).then(function(){
                            if(repliesContainer){
                                repliesContainer.removeAttribute('hidden');
                                repliesContainer.insertAdjacentHTML('beforeend', buildReplyHtml(entry, parentId, isPendingReply));
                            }
                            if(window.__toast) {
                                window.__toast(
                                    data.is_admin
                                        ? CFG.l10n.comment_posted
                                        : CFG.l10n.comment_pending,
                                    'success'
                                );
                            }
                        });
                    }
                })
                .catch(function(e){
                    if(window.__toast) window.__toast(e.message || ERR_GENERIC, 'error');
                })
                .finally(function(){
                    sendBtn.disabled = false;
                    sendBtn.classList.remove('is-loading');
                });
            return;
        }

        /* Load replies */
        var loadBtn = e.target.closest('[data-load-replies]');
        if(loadBtn){
            loadReplies(loadBtn.getAttribute('data-load-replies'), loadBtn);
            return;
        }

        /* Edit pending comment */
        var editPending = e.target.closest('[data-edit-pending]');
        if(editPending){
            startEdit(editPending.getAttribute('data-edit-pending'));
            return;
        }

        /* Like button */
        var likeBtn = e.target.closest('[data-like]');
        if(likeBtn){
            var cid = parseInt(likeBtn.getAttribute('data-like'), 10);
            var countEl = likeBtn.querySelector('.rw-like-count');
            var wasLiked = likeBtn.classList.contains('liked');
            var oldCount = parseInt(countEl.textContent, 10) || 0;

            /* Optimistic update */
            likeBtn.classList.toggle('liked');
            var newCount = wasLiked ? Math.max(0, oldCount - 1) : oldCount + 1;
            countEl.textContent = newCount > 0 ? newCount : '';
            toggleLikedId(cid);

            var fd = new FormData();
            fd.append('_token', csrfToken());
            fd.append('comment_id', cid);

            fetch(likeUrl, { method: 'POST', body: fd })
                .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
                .then(function(data){
                    /* Sync with server truth */
                    countEl.textContent = data.count > 0 ? data.count : '';
                    if(data.liked !== likeBtn.classList.contains('liked')){
                        likeBtn.classList.toggle('liked');
                        /* Re-sync localStorage */
                        var arr = getLikedIds();
                        var idx = arr.indexOf(cid);
                        if(data.liked && idx === -1) arr.push(cid);
                        if(!data.liked && idx !== -1) arr.splice(idx, 1);
                        setLikedIds(arr);
                    }
                })
                .catch(function(){
                    /* Revert optimistic update */
                    likeBtn.classList.toggle('liked');
                    countEl.textContent = oldCount > 0 ? oldCount : '';
                    toggleLikedId(cid);
                });
            return;
        }
    });

    /* ===== 3-DOT MENU PORTAL + REPORT DIALOG =====
       The menu popup and report dialog are appended to <body> (portal) so the
       card's overflow:hidden can't clip them, and positioned fixed at the
       kebab button. Items depend on the viewer: admin → Delete (+ Report on
       non-admin comments); Pro/verified → Report on non-admin comments. */
    var menuPop = null, menuTargetId = null;
    function buildMenuItems(isAdminCmt){
        var html = '';
        // Admin edits their OWN (admin-authored) comment with no time limit —
        // the backend commentUpdate admin branch enforces the same is_admin gate.
        if (isAdminSession && isAdminCmt) {
            html += '<button type="button" class="rw-menu-item rw-menu-edit" data-act="edit">' + PENCIL_SVG + '<span>' + escHtml(editLabel) + '</span></button>';
        }
        if (isAdminSession) {
            html += '<button type="button" class="rw-menu-item rw-menu-del" data-act="delete">' + TRASH_SVG + '<span>' + escHtml(deleteLabel) + '</span></button>';
        }
        // Report: admin + Pro/verified, but never against an admin comment.
        if (!isAdminCmt && canModerate) {
            html += '<button type="button" class="rw-menu-item rw-menu-rep" data-act="report">' + FLAG_SVG + '<span>' + escHtml(reportLabel) + '</span></button>';
        }
        return html;
    }
    function closeMenu(){
        if (menuPop) menuPop.hidden = true;
        menuTargetId = null;
        var open = cmtsList.querySelector('.rw-menu-btn[aria-expanded="true"]');
        if (open) open.setAttribute('aria-expanded', 'false');
    }
    function toggleCommentMenu(btn){
        var id = btn.getAttribute('data-menu');
        var isAdminCmt = btn.getAttribute('data-admin-cmt') === '1';
        if (menuPop && !menuPop.hidden && menuTargetId === id) { closeMenu(); return; }
        var items = buildMenuItems(isAdminCmt);
        if (!items) return;
        if (!menuPop) {
            menuPop = document.createElement('div');
            menuPop.className = 'rw-menu-pop';
            menuPop.hidden = true;
            document.body.appendChild(menuPop);
            menuPop.addEventListener('click', onMenuItemClick);
        }
        menuPop.innerHTML = items;
        menuTargetId = id;
        menuPop.hidden = false;
        var r = btn.getBoundingClientRect();
        var w = menuPop.offsetWidth || 172;
        var h = menuPop.offsetHeight || 90;
        var left = Math.max(8, r.right - w);
        var top = r.bottom + 6;
        if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 6);
        menuPop.style.left = left + 'px';
        menuPop.style.top = top + 'px';
        btn.setAttribute('aria-expanded', 'true');
    }
    function onMenuItemClick(e){
        var item = e.target.closest('[data-act]');
        if (!item) return;
        var act = item.getAttribute('data-act');
        var id = menuTargetId;
        closeMenu();
        if (!id) return;
        if (act === 'delete') doDeleteComment(id);
        else if (act === 'report') openReportDialog(id);
        else if (act === 'edit') startAdminEdit(id);
    }
    document.addEventListener('click', function(e){
        if (!menuPop || menuPop.hidden) return;
        if (e.target.closest('.rw-menu-pop')) return;
        if (e.target.closest('[data-menu]')) return; // toggle handles it
        closeMenu();
    });
    window.addEventListener('scroll', function(){ if (menuPop && !menuPop.hidden) closeMenu(); }, true);
    window.addEventListener('resize', function(){ if (menuPop && !menuPop.hidden) closeMenu(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') { closeMenu(); closeReportDialog(); } });

    /* ===== DELETE (admin only) ===== */
    function doDeleteComment(id){
        if (!window.confirm(deleteConfirmLabel)) return;
        var fd = new FormData();
        fd.append('_token', csrfToken());
        fd.append('comment_id', id);
        fetch(commentDeleteUrl, { method: 'POST', body: fd })
            .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data){
                if (!data.success) throw new Error(data.error || '');
                var el = cmtsList.querySelector('.rw-cmt[data-cid="' + id + '"]');
                if (el) {
                    // Rescue the shared reply form if it was relocated into the
                    // comment being deleted. Deleting a REPLY that currently
                    // hosts the moved rwReplyForm_<topId> would otherwise orphan
                    // the rest of that thread's Reply buttons (they target the
                    // form id → the [data-reply] handler no-ops on a null form =
                    // dead button, same class as the loadReplies bug). Re-home
                    // the form on its top-level comment so it survives the
                    // removal. No-op in the common case (no form inside el).
                    var stranded = el.querySelector('.rw-reply-form');
                    if (stranded) {
                        var home = document.getElementById('cid-' + stranded.id.replace('rwReplyForm_', ''));
                        if (home && home !== el && !el.contains(home)) home.appendChild(stranded);
                        else stranded.remove();
                    }
                    el.remove();
                }
                if (data.top_level) {
                    totalCommentCount = Math.max(0, totalCommentCount - 1);
                    cmtsTitle.textContent = pluralComments(totalCommentCount);
                    if (totalCommentCount === 0 && !getMyPendingTops().length) cmtsContainer.hidden = true;
                }
                if (window.__toast) window.__toast(deletedLabel, 'success');
            })
            .catch(function(){ if (window.__toast) window.__toast(ERR_GENERIC, 'error'); });
    }

    /* ===== ADMIN INLINE EDIT (own admin comment, no time limit) =====
       Swaps the comment body for the admin markdown editor (toolbar + live
       preview), POSTs the new source to commentUpdate, and re-renders the card
       body in place from the server's freshly-rendered comment_html — the
       actions row (reply / like) is restored untouched, so a deep-thread reply
       keeps its context instead of collapsing the way a full loadComments()
       would. The raw markdown is read from the card's data-md attribute. */
    function startAdminEdit(id){
        var card = cmtsList.querySelector('.rw-cmt[data-cid="' + id + '"]');
        if (!card || card.dataset.editing === '1') return;
        var textEl = card.querySelector('.rw-cmt-text');
        var actionsEl = card.querySelector('.rw-cmt-actions');
        if (!textEl || !actionsEl) return;
        card.dataset.editing = '1';

        var rawMd = '';
        try { rawMd = decodeURIComponent(card.dataset.md || ''); } catch(_) { rawMd = textEl.textContent || ''; }

        var origTextHtml = textEl.innerHTML;
        var origActionsHtml = actionsEl.innerHTML;

        textEl.innerHTML = '<textarea class="rw-cmt-edit-area" maxlength="2000"></textarea><div class="md-preview" hidden></div>';
        var ta = textEl.querySelector('textarea');
        ta.value = rawMd;
        actionsEl.innerHTML = '<button type="button" class="rw-cmt-save-btn rw-cmt-admin-save">' + escHtml(saveLabel) + '</button>'
            + '<button type="button" class="rw-cmt-cancel-btn rw-cmt-admin-cancel">' + escHtml(cancelLabel) + '</button>';

        ta.style.height = 'auto';
        ta.style.height = Math.min(ta.scrollHeight, 300) + 'px';
        ta.focus();

        // Mount the same markdown toolbar + live preview used by admin reply forms.
        var preview = textEl.querySelector('.md-preview');
        loadAdminMarkdown().then(function(mod){
            if (mod) mod.mount(ta, {
                previewEl: preview,
                previewUrl: adminPreviewUrl,
                csrfToken: csrfToken(),
                labels: mdLabels,
                postProcess: mentionizeAdminHtml
            });
        }).catch(function(){ /* silent — plain textarea still works */ });

        function restore(){
            card.dataset.editing = '';
            textEl.innerHTML = origTextHtml;
            actionsEl.innerHTML = origActionsHtml;
        }

        actionsEl.querySelector('.rw-cmt-admin-cancel').addEventListener('click', restore);
        actionsEl.querySelector('.rw-cmt-admin-save').addEventListener('click', function(){
            var saveBtn = this;
            var newText = ta.value.trim();
            if (!newText){ flashRequired(ta); return; }
            saveBtn.disabled = true;

            var fd = new FormData();
            fd.append('_token', csrfToken());
            fd.append('comment_id', id);
            fd.append('comment', newText);

            fetch(commentUpdateUrl, { method: 'POST', body: fd })
                .then(function(r){ if(!r.ok) return parseError(r).then(function(m){ throw new Error(m); }); return r.json(); })
                .then(function(resp){
                    if (!resp.success || !resp.comment) throw new Error(ERR_GENERIC);
                    var entry = resp.comment;
                    return ensureSanitizerFor([entry]).then(function(){
                        card.dataset.editing = '';
                        card.dataset.md = encodeURIComponent(entry.comment || newText);
                        textEl.innerHTML = renderCommentBody(entry);
                        actionsEl.innerHTML = origActionsHtml;
                        if (window.__toast) window.__toast(commentUpdatedLabel, 'success');
                    });
                })
                .catch(function(e){
                    saveBtn.disabled = false;
                    if (window.__toast) window.__toast(e.message || ERR_GENERIC, 'error');
                });
        });
    }

    /* ===== REPORT DIALOG (admin + Pro/verified) ===== */
    var reportOv = null, reportTargetId = null;
    function ensureReportDialog(){
        if (reportOv) return reportOv;
        reportOv = document.createElement('div');
        reportOv.className = 'rw-report-ov';
        reportOv.hidden = true;
        var reasonsHtml = '';
        ['spam', 'offensive', 'off_topic', 'other'].forEach(function(k){
            reasonsHtml += '<label><input type="radio" name="rw-report-reason" value="' + k + '"><span>' + escHtml(reportReasons[k] || k) + '</span></label>';
        });
        reportOv.innerHTML = '<div class="rw-report-box" role="dialog" aria-modal="true" aria-labelledby="rwReportTitle">'
            + '<h4 id="rwReportTitle">' + escHtml(reportTitleLabel) + '</h4>'
            + '<div class="rw-report-reasons">' + reasonsHtml + '</div>'
            + '<textarea class="rw-report-note" maxlength="500" placeholder="' + escHtml(reportNoteLabel) + '"></textarea>'
            + '<div class="rw-report-actions">'
            + '<button type="button" class="rw-report-cancel">' + escHtml(cancelLabel) + '</button>'
            + '<button type="button" class="rw-report-send">' + escHtml(reportSubmitLabel) + '</button>'
            + '</div></div>';
        document.body.appendChild(reportOv);
        reportOv.addEventListener('click', function(e){
            if (e.target === reportOv || e.target.closest('.rw-report-cancel')) { closeReportDialog(); return; }
            if (e.target.closest('.rw-report-send')) submitReport();
        });
        return reportOv;
    }
    function openReportDialog(id){
        ensureReportDialog();
        reportTargetId = id;
        var checked = reportOv.querySelector('input[name="rw-report-reason"]:checked');
        if (checked) checked.checked = false;
        var note = reportOv.querySelector('.rw-report-note');
        if (note) note.value = '';
        var send = reportOv.querySelector('.rw-report-send');
        if (send) send.disabled = false;
        reportOv.hidden = false;
    }
    function closeReportDialog(){
        if (reportOv) reportOv.hidden = true;
        reportTargetId = null;
    }
    function submitReport(){
        if (!reportOv || !reportTargetId) return;
        var reason = reportOv.querySelector('input[name="rw-report-reason"]:checked');
        if (!reason) { if (window.__toast) window.__toast(reportChooseLabel, 'warning'); return; }
        var note = reportOv.querySelector('.rw-report-note');
        var send = reportOv.querySelector('.rw-report-send');
        if (send) send.disabled = true;
        var fd = new FormData();
        fd.append('_token', csrfToken());
        fd.append('comment_id', reportTargetId);
        fd.append('reason', reason.value);
        if (note && note.value.trim()) fd.append('note', note.value.trim());
        fetch(commentReportUrl, { method: 'POST', body: fd })
            .then(function(r){ if(!r.ok) return parseError(r).then(function(m){ throw new Error(m); }); return r.json(); })
            .then(function(data){
                closeReportDialog();
                if (window.__toast) window.__toast((data && data.message) || reportThanksLabel, 'success');
            })
            .catch(function(e){
                if (send) send.disabled = false;
                if (window.__toast) window.__toast(e.message || ERR_GENERIC, 'error');
            });
    }

    /* ===== STAR RATING ===== */
    function setStars(val) {
        stars.forEach(function(b, i) { b.classList.toggle('active', i < val); });
    }
    function lockStars() {
        locked = true;
        stars.forEach(function(b) { b.style.cursor = 'default'; });
    }
    function unlockStars() {
        locked = false;
        stars.forEach(function(b) { b.style.cursor = 'pointer'; });
    }
    function showCommentForm() {
        commentEl.style.display = 'block';
        if (toggleEl) toggleEl.style.display = 'none';
    }

    function checkExistingRating() {
        fetch(checkUrl + '?tool_slug=' + encodeURIComponent(slug))
        .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(data) {
            if (data.rated && data.rating) {
                currentRating = data.rating;
                setStars(currentRating);
                lockStars();
                changeEl.style.display = 'block';
                showCommentForm();
            }
        })
        .catch(function() {});
    }

    /* Fire when widget scrolls into view OR after a short delay regardless,
       whichever happens first. Both paths early-out via the _hydrated guard
       so we never double-fetch.

       Why the unconditional fallback timer: the original IntersectionObserver
       gate was added 2026-02-20 (commit 37b5d3ce5) as a perf micro-opt — skip
       the GET when a visitor never scrolls down. But on slow mobile / 3G
       connections the deferred tool-rating script can finish parsing AFTER
       the user has already scrolled past the rating widget; the IO then
       observes from the new position, sees isIntersecting:false, and waits
       for a state CHANGE that never comes (users read comments, they don't
       scroll back up past stars to re-trigger). Result: SSR comment skeleton
       (no avatars, no reply button, no edit, no like) stays forever — the
       user-visible TIMBRICA-FRONTEND-513-followup Артём reported on 2026-05-28.

       The fallback at 3 s is cheap (one ~5 KB GET per pageview on pages that
       include the component) and closes the race. The IO branch stays because
       it shaves ~3 s off the median for the common "user scrolls down within
       3 s" case. */
    var _hydrated = false;
    var _io = null;
    function hydrate() {
        if (_hydrated) return;
        _hydrated = true;
        if (_io) { try { _io.disconnect(); } catch (_) {} }
        checkExistingRating();
        loadComments();
    }
    if ('IntersectionObserver' in window) {
        _io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) hydrate();
        }, { rootMargin: '200px' });
        _io.observe(starsEl);
    }
    setTimeout(hydrate, 3000);

    /* Hover */
    stars.forEach(function(btn) {
        btn.addEventListener('mouseenter', function() {
            if (locked) return;
            var val = +btn.dataset.v;
            stars.forEach(function(b, i) { b.classList.toggle('hover', i < val); });
        });
    });
    starsEl.addEventListener('mouseleave', function() {
        stars.forEach(function(b) { b.classList.remove('hover'); });
    });

    /* Star click */
    stars.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var v = +btn.dataset.v;
            if (locked) {
                // Pre-2026-06-03 a click on a locked star (user already rated)
                // returned silently — the silent-click detector picked it up
                // as a rage signal (e.g. Irwan /id/equalizer 2026-06-02 first
                // "Sangat baik" tap fired det:2). Now we surface a visible
                // bounce on the star + scroll the "rwChange" link into view
                // so the user understands their rating is in and can change
                // it if they want.
                // Element.animate (WAAPI) is Safari 13.1+ — absent on iOS ≤12
                // WebKit shells (Yandex iOS 12 threw "undefined is not a
                // function", TIMBRICA-FRONTEND-B4). The bounce is decorative;
                // skip it there — the rwChange scroll cue below still runs.
                if (btn.animate) btn.animate(
                    [{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }],
                    { duration: 220, easing: 'cubic-bezier(.4,0,.2,1)' }
                );
                if (changeEl && changeEl.style.display !== 'none') {
                    try { changeEl.scrollIntoView({ block: 'nearest' }); } catch(_){}
                    if (changeEl.animate) changeEl.animate(
                        [{ background: 'rgba(56,189,248,0)' }, { background: 'rgba(56,189,248,.12)' }, { background: 'rgba(56,189,248,0)' }],
                        { duration: 800, easing: 'ease-in-out' }
                    );
                }
                return;
            }
            if (window.__aeRating) window.__aeRating(v);
            submitRating(v);
        });
    });

    var offlineSavedMsg = CFG.l10n.rating_saved_offline;

    function queueRatingOffline(val) {
        var req = indexedDB.open('timbrica-sync', 1);
        req.onupgradeneeded = function(e) { e.target.result.createObjectStore('pending-ratings', { keyPath: 'id', autoIncrement: true }); };
        req.onsuccess = function() {
            var db = req.result;
            var tx = db.transaction('pending-ratings', 'readwrite');
            tx.objectStore('pending-ratings').add({ url: storeUrl, csrfToken: csrfToken(), toolSlug: slug, rating: val, ts: Date.now() });
            tx.oncomplete = function() {
                if ('serviceWorker' in navigator && 'SyncManager' in window) {
                    // Sentry 118050573 (Chrome 147 Android, /ru/iq-test): inner
                    // `reg.sync.register('sync-ratings')` returns a Promise that
                    // wasn't chained — when the browser disables Background Sync
                    // (Android battery saver, enterprise policy, etc.) it
                    // rejects with `UnknownError: Background Sync is disabled`
                    // which then becomes an unhandledrejection. `return` chains
                    // the inner promise into the outer `.catch(function(){})`.
                    navigator.serviceWorker.ready.then(function(reg) {
                        return reg.sync.register('sync-ratings');
                    }).catch(function(){});
                }
                currentRating = val;
                thanksText.textContent = offlineSavedMsg;
                thanksEl.style.display = 'block';
                changeEl.style.display = 'block';
                showCommentForm();
                setTimeout(function() { thanksEl.style.display = 'none'; }, 4000);
            };
        };
    }

    function submitRating(val) {
        setStars(val);
        lockStars();
        errorEl.style.display = 'none';

        var fd = new FormData();
        fd.append('_token', csrfToken());
        fd.append('tool_slug', slug);
        fd.append('rating', val);

        fetch(storeUrl, { method: 'POST', body: fd })
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(data) {
                if (data.success) {
                    currentRating = val;
                    thanksText.textContent = data.updated ? thankYouUpdated : thankYouNew;
                    thanksEl.style.display = 'block';
                    changeEl.style.display = 'block';
                    showCommentForm();
                    setTimeout(function() { thanksEl.style.display = 'none'; }, 3000);
                } else {
                    errorEl.textContent = data.error || '';
                    errorEl.style.display = 'block';
                    unlockStars();
                }
            })
            .catch(function() { queueRatingOffline(val); });
    }

    window.addEventListener('online', function() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then(function(reg) {
                if ('SyncManager' in window) { reg.sync.register('sync-ratings').catch(function(){}); }
                else if (navigator.serviceWorker.controller) { navigator.serviceWorker.controller.postMessage({ type: 'REPLAY_RATINGS' }); }
            }).catch(function(){});
        }
    });

    if (changeLink) changeLink.addEventListener('click', function(e) {
        e.preventDefault();
        unlockStars();
        changeEl.style.display = 'none';
        thanksEl.style.display = 'none';
    });

    if (toggleLink) toggleLink.addEventListener('click', function(e) {
        e.preventDefault();
        showCommentForm();
    });

    /* ===== PENDING COMMENTS (localStorage) =====
       Schema: LS_KEY holds { "<slug>:<locale>": [ {id, parent_id, author_name, comment, ts}, ... ] }.
       parent_id is null for top-level comments, the parent comment id for
       replies. Legacy slots (a single object, pre-array schema) are wrapped
       into a one-element array on read. Entries expire client-side after 30
       days — the server status endpoint filters by requester IP, so a guest
       on a rotating mobile IP may NEVER get an explicit verdict for his id;
       the TTL is the only guaranteed cleanup for that case. */
    var PENDING_TTL_MS = 30 * 24 * 60 * 60 * 1000;
    function pendingSlotKey() { return slug + ':' + window.__LOCALE; }
    function getPendingComments() {
        try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; } catch(e) { return {}; }
    }
    function normalizePendingList(raw) {
        var list;
        if (Array.isArray(raw)) list = raw;
        else if (raw && raw.id) list = [raw]; /* legacy single-object slot */
        else list = [];
        var now = Date.now();
        var out = [];
        for (var i = 0; i < list.length; i++) {
            var e = list[i];
            if (!e || !e.id) continue;
            if (!e.ts) e.ts = now;
            if (now - e.ts > PENDING_TTL_MS) continue; /* 30-day client-side TTL */
            out.push(e);
        }
        return out;
    }
    function getPendingList() {
        var all = getPendingComments();
        var key = pendingSlotKey();
        var raw = all[key];
        var list = normalizePendingList(raw);
        /* Persist migrations (legacy object → array) and TTL purges on read */
        if (raw !== undefined && JSON.stringify(list) !== JSON.stringify(raw)) {
            if (list.length) all[key] = list; else delete all[key];
            localStorage.setItem(LS_KEY, JSON.stringify(all));
        }
        return list;
    }
    function getMyPendingTops() {
        return getPendingList().filter(function(p){ return !p.parent_id; });
    }
    function getPendingById(id) {
        var list = getPendingList();
        for (var i = 0; i < list.length; i++) {
            if (String(list[i].id) === String(id)) return list[i];
        }
        return null;
    }
    function savePendingComment(id, name, text, parentId) {
        var all = getPendingComments();
        var key = pendingSlotKey();
        var list = normalizePendingList(all[key]);
        var entry = { id: id, parent_id: parentId || null, author_name: name, comment: text, ts: Date.now() };
        var replaced = false;
        for (var i = 0; i < list.length; i++) {
            if (String(list[i].id) === String(id)) {
                if (!parentId) entry.parent_id = list[i].parent_id || null; /* edit path keeps the original parent */
                list[i] = entry;
                replaced = true;
                break;
            }
        }
        if (!replaced) list.push(entry);
        all[key] = list;
        localStorage.setItem(LS_KEY, JSON.stringify(all));
    }
    function removePendingComment(id) {
        var all = getPendingComments();
        var key = pendingSlotKey();
        var list = normalizePendingList(all[key]).filter(function(p){ return String(p.id) !== String(id); });
        if (list.length) all[key] = list; else delete all[key];
        localStorage.setItem(LS_KEY, JSON.stringify(all));
    }

    /* Inject the viewer's own pending replies into their parents' reply
       containers. Server read paths return approved rows only, so without
       this a just-submitted reply silently vanishes on reload. Insert-only
       by design: the shared reply form (rwReplyForm_<id>) is ONE DOM node
       that gets relocated into these containers — rebuilding a container
       with innerHTML here would destroy it (see the loadReplies guard). */
    function injectPendingReplies(onlyParentId) {
        getPendingList().forEach(function(p){
            if (!p.parent_id) return;
            if (onlyParentId && String(p.parent_id) !== String(onlyParentId)) return;
            var container = document.getElementById('rwReplies_' + p.parent_id);
            if (!container) return; /* parent comment not on this page — skip silently */
            var approved = container.querySelector('.rw-cmt[data-cid="' + p.id + '"]:not(.rw-cmt-new)');
            if (approved) {
                /* The approved copy came back from the server — drop the
                   local placeholder so the reply never doubles. */
                var stale = container.querySelector('.rw-cmt-new[data-cid="' + p.id + '"]');
                if (stale) stale.remove();
                removePendingComment(p.id);
                return;
            }
            if (container.querySelector('[data-cid="' + p.id + '"]')) return; /* already injected */
            container.removeAttribute('hidden');
            container.insertAdjacentHTML('beforeend', buildReplyHtml({
                id: p.id,
                author_name: p.author_name,
                comment: p.comment
            }, p.parent_id, true));
        });
    }

    function startEdit(id) {
        var data = getPendingById(id);
        if (!data) return;
        var cmt = document.getElementById('rwPendingCmt_' + data.id);
        if (!cmt) return;
        var textEl = cmt.querySelector('.rw-cmt-text');
        var actionsEl = cmt.querySelector('.rw-cmt-actions');

        textEl.innerHTML = '<input type="text" class="rw-cmt-edit-name" id="rwEditName" value="' + escHtml(data.author_name) + '" maxlength="100">'
            + '<textarea class="rw-cmt-edit-area" id="rwEditArea" maxlength="2000">' + escHtml(data.comment) + '</textarea>';
        actionsEl.innerHTML = '<button type="button" class="rw-cmt-save-btn" id="rwSaveEdit">' + saveLabel + '</button>'
            + '<button type="button" class="rw-cmt-cancel-btn" id="rwCancelEdit">' + cancelLabel + '</button>';

        document.getElementById('rwSaveEdit').addEventListener('click', function(){
            saveEditHandler(data.id);
        });
        document.getElementById('rwCancelEdit').addEventListener('click', function(){
            /* Reload comments to restore */
            loadComments();
        });
    }

    function saveEditHandler(id) {
        var nameInput2 = document.getElementById('rwEditName');
        var areaInput = document.getElementById('rwEditArea');
        if (!nameInput2 || !areaInput) return;

        var newName = nameInput2.value.trim();
        var newText = areaInput.value.trim();
        if (!newName || !newText) return;

        var data = getPendingById(id);
        if (!data) return;

        var saveBtn = document.getElementById('rwSaveEdit');
        saveBtn.disabled = true;

        var fd = new FormData();
        fd.append('_token', csrfToken());
        fd.append('comment_id', data.id);
        fd.append('author_name', newName);
        fd.append('comment', newText);

        fetch(commentUpdateUrl, { method: 'POST', body: fd })
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(resp) {
                if (resp.success) {
                    savePendingComment(data.id, newName, newText);
                    loadComments();
                    if (window.__toast) window.__toast(commentUpdatedLabel, 'success');
                }
            })
            .catch(function() { if (window.__toast) window.__toast(((window.__commonStrings||{}).ui_error || "Error"), 'error'); })
            .finally(function() { saveBtn.disabled = false; });
    }

    /* Check pending status */
    function checkPendingStatus() {
        var list = getPendingList();
        if (!list.length) return;

        /* The endpoint accepts up to 20 ids per call — one batched request
           covers every realistic volume of local pendings. */
        var qs = [];
        for (var i = 0; i < list.length && i < 20; i++) {
            qs.push('ids[]=' + encodeURIComponent(list[i].id));
        }

        fetch(commentStatusUrl + '?' + qs.join('&'))
            .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function(resp) {
                var removed = false;
                list.forEach(function(entry) {
                    var status = resp.statuses && resp.statuses[entry.id];
                    /* Remove ONLY on an explicit moderation verdict. A missing
                       status is NOT one: the endpoint filters by requester IP,
                       so a guest whose (mobile) IP rotated gets no row for his
                       own comment — deleting here erased real users' pending
                       placeholders. Keep the entry; the 30-day TTL in
                       normalizePendingList() bounds stale ones. */
                    if (status === 'approved' || status === 'rejected') {
                        removePendingComment(entry.id);
                        removed = true;
                    }
                });
                if (removed) {
                    loadComments(); /* Reload to get fresh approved list */
                }
            })
            .catch(function() {});
    }

    /* Defer pending check */
    if (getPendingList().length) {
        setTimeout(checkPendingStatus, 2000);
    }

    /* ===== COMMENT SUBMISSION ===== */
    if (submitBtn) submitBtn.addEventListener('click', function() {
        var text = textInput.value.trim();
        var name;
        if (currentUser) {
            // Logged-in path: name comes from the account — no free-text field to fill.
            name = currentUser.display_name || '';
        } else {
            if (!nameInput) return;
            name = nameInput.value.trim();
            if (!name) { flashRequired(nameInput); if(window.__toast) window.__toast(nameRequiredLabel,'warning'); return; }
        }
        if (!text) { flashRequired(textInput); return; }

        errorEl.style.display = 'none';
        submitBtn.disabled = true;
        if (!currentUser) localStorage.setItem('timbrica_cmt_name', name);

        var fd = new FormData();
        fd.append('_token', csrfToken());
        fd.append('tool_slug', slug);
        fd.append('author_name', name);
        fd.append('comment', text);

        fetch(commentUrl, { method: 'POST', body: fd })
            .then(function(r) {
                if (!r.ok) return parseError(r).then(function(msg){ throw new Error(msg); });
                return r.json();
            })
            .then(function(data) {
                if (data.success) {
                    savePendingComment(data.comment_id, name, text);
                    loadComments();
                    if (nameInput) nameInput.value = '';
                    textInput.value = '';
                    commentOk.style.display = 'block';
                    setTimeout(function() { commentOk.style.display = 'none'; }, 5000);
                    var counter = document.getElementById('rwCharCount');
                    if(counter) counter.textContent = '';
                } else {
                    errorEl.textContent = data.error || ERR_GENERIC;
                    errorEl.style.display = 'block';
                }
            })
            .catch(function(e) {
                errorEl.textContent = e.message || ERR_GENERIC;
                errorEl.style.display = 'block';
            })
            .finally(function() { submitBtn.disabled = false; });
    });

    // ─── Anchor jump from "you have a new reply" email ───────────────────
    // URL shape: /{locale}/{tool_slug}#cid-{N}. If the targeted comment is
    // already in the DOM (SSR rendered the parent + last reply), scroll into
    // view (block:'nearest' per CLAUDE.md — only scrolls if off-screen) and
    // briefly highlight it. If the target isn't in the DOM yet, try to load
    // more replies for its parent (when it's a reply on a thread whose tail
    // is folded). Runs after the comment list mounts so JS-rendered cards
    // are findable too.
    function focusAnchorComment(){
        var m = (location.hash || '').match(/^#cid-(\d+)$/);
        if (!m) return;
        var cid = m[1];
        var el = document.getElementById('cid-' + cid);
        if (el) {
            try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch(_) {}
            el.classList.add('rw-cmt-focus');
            setTimeout(function(){ el.classList.remove('rw-cmt-focus'); }, 3500);
            return true;
        }
        // Not in DOM — try expanding replies for any parent thread on this page.
        // The "show more replies" expander is wired further up; we trigger it
        // for every visible parent and re-check on each batch.
        var expanders = document.querySelectorAll('[data-show-replies], .rw-show-more-replies');
        if (!expanders.length) return false;
        expanders.forEach(function(b){ try { b.click(); } catch(_) {} });
        // Re-check after each thread loads its replies; max ~3 s of polling.
        var attempts = 0;
        var poll = setInterval(function(){
            attempts++;
            var found = document.getElementById('cid-' + cid);
            if (found) {
                clearInterval(poll);
                try { found.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch(_) {}
                found.classList.add('rw-cmt-focus');
                setTimeout(function(){ found.classList.remove('rw-cmt-focus'); }, 3500);
            } else if (attempts >= 30) {
                clearInterval(poll);
            }
        }, 100);
    }
    // Run after the comment list has had a chance to mount.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function(){ setTimeout(focusAnchorComment, 200); });
    } else {
        setTimeout(focusAnchorComment, 200);
    }
    window.addEventListener('hashchange', focusAnchorComment);
})();
